import { render } from "./ChooseClass.vue?vue&type=template&id=1a278828&scoped=true"
import script from "./ChooseClass.vue?vue&type=script&lang=js"
export * from "./ChooseClass.vue?vue&type=script&lang=js"

import "./ChooseClass.vue?vue&type=style&index=0&id=1a278828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a278828"]])

export default __exports__